/*
Sohel 11/17/2022 2700912712 Added System Notes functionality
Sohel 11/22/2022 2700912712 System notes added add notes button
Akhila 12/09/2022 2700912712 Added form Notes
Ashraf 12/09/2022 2700912712 fixed notes reset issue
Dilip 12/12/2022 2700912712 changed tooltip
lalitha 15/12/2022 2700912712 added access role in filter rule group
Ashraf 12/19/2022 2700912712 fixed notes search page break
kavyareddy12/20/2022 2700912712 Added dropdown for createdBy and noteType
Raghu 12/26/2022 2700912712 Removed Dialog Component
Raghu 12/28/2022 2700912712 Table Footer Stylings
Raghu 02/28/2023 2700912712 added new class buttons
Akhila 06/07/2023 2700912712 added breadcrum code and description
Gireesh 15-12-2023 2700912712 updated payload
*/
import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {
  systempostNotesFilterInformation,
  resetPostStatus,
  systemNotesResetToast,
} from '../../../../../redux/reducers/BRE/SystemNotes';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import DialogBox from './../../../../../components/DialogBox/index';
import SearchNotesForm from '../../../../../components/SearchNotes/searchNotesForm';

const FilterNotes = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  filterData,
  filterRuleRoleAccess,
}) => {
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const {systemnotesStatus, systemisLoading} = useSelector(({systemNotes}) => systemNotes);
  useEffect(() => {
    if (systemnotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      dispatch(resetPostStatus());
      setTimeout(() => {
        dispatch(systemNotesResetToast());
      }, 1500);
    }
  }, [systemnotesStatus]);
  const dispatchRecordFormatSystemNotes = (data) => {
    dispatch(
      systempostNotesFilterInformation({
        code: filterData ? filterData?.code : '',
        noteText: data,
        reportId: filterData?.groupId ? filterData?.groupId : 0,
      }),
    );
  };
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        // minWidth: "550px",
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created By',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const reportMasterDisableAdd = roleData?.window?.['Business Rule Engine']?.['BR'];

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={systemisLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            reportMasterDisableAdd={reportMasterDisableAdd}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          filterData={filterData}
          moduleName={'datacalculation'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `rules/find/all/filternotes`;
                const bodyObj = {
                  code: filterData?.code,
                  frameworkId: filterData?.groupId ? filterData?.groupId : 0,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: '',
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!filterData?.code) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={!filterRuleRoleAccess?.add}
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                disabled: !filterRuleRoleAccess?.add,
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
};

export default FilterNotes;
